<template>
    <div class="content">
        <div class="top-img"></div>
        <div class="order">
            <div class="order-info">
                <el-form :model="form" :rules="rules" ref="form" label-width="140px">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="工程名称" prop="title">
                                <el-input v-model="form.title" placeholder="请输入工程名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="用工需求" prop="need">
                                <el-input v-model="form.need" type="textarea" placeholder="请输入用工需求"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="工程简介" prop="introduction">
                                <el-input v-model="form.introduction" type="textarea" placeholder="请输入工程简介"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="工程所需技能" prop="ability">
                                <el-input v-model="form.ability" type="textarea" placeholder="请输入工程所需技能"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="工程所需资质" prop="qualification">
                                <el-input v-model="form.qualification" placeholder="请输入工程所需资质"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="工作地点" prop="address">
                                <el-input v-model="form.address" placeholder="请输入工作地点"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="接单说明" prop="instruction">
                                <el-input v-model="form.instruction" type="textarea" placeholder="请输入接单说明"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="计划工程总额" prop="price">
                                <el-input v-model="form.price" placeholder="请输入计划工程总额">
                                    <template slot="prepend">总价</template>
                                    <template slot="append">/￥</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="人数限制" prop="number">
                                <el-input v-model="form.number" placeholder="请输入人数限制"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="预计工期（天）" prop="days">
                                <el-input v-model="form.days" placeholder="请输入预计工期"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="单价上限（元/天）" prop="up">
                                <el-input v-model="form.up" placeholder="请输入单价上限"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="单价下限（元/天）" prop="down">
                                <el-input v-model="form.down" placeholder="请输入单价下限"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div class="flex-row" style="display: flex;justify-content: center;">
                    <div class="work-cont bot">
                        <button class="apply" @click="submit(1)">保存订单</button>
                        <button class="saveOrder" @click="submit(0)">发布订单</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import { addNeed } from "../../http/api/ordinary.js";

    export default {
        data() {
            return {
                form: {
                    title: '',
                    need: '',
                    introduction: '',
                    ability: '',
                    qualification: '',
                    address: '',
                    instruction: '',
                    price: '',
                    number: '',
                    days: '',
                    up: '',
                    down: '',
                    id: ''
                },
                rules:{
                    title: [
                        {required: true, message: '请输入工程名称', trigger: 'blur' }
                    ],
                    address: [
                        {required: true, message: '请输入地点', trigger: 'blur' }
                    ],
                    price: [
                        {required: true, message: '请输入计划工程总额', trigger: 'blur' },
                        { validator: this.validateAcquaintance, trigger: 'blur'}
                    ],
                }
            };
        },
        methods: {
            submit(obj){
                if(obj == 1){
                    this.form.status = -1;
                } else {
                    this.form.status = obj;
                }
                this.form.id = this.form.id || 0;
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        addNeed(this.form).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    message: "新增成功",
                                    type: "success",
                                    duration: 1000,
                                    onClose: () => {
                                        this.$router.push({
                                            path: '/personalCenter/orderShare'
                                        })
                                    },
                                });
                            } else {
                                this.$message.error(res.msg);
                            }
                        });
                    }else {
                        console.log("error submit!!");
                        return false;
                    }
                })
            },
            async validateAcquaintance(rule, value, callback){
                let reg = /^\d+(.\d{1,2})?$/;;
                console.log(!reg.test(value))
                if (!reg.test(value)) {
                    callback(new Error('请输入俩位小数的数字值'));
                } else {
                    if (value > 0 && value < 100000000) {
                        callback()
                    } else {
                        callback(new Error('总额要小于1亿'))
                    }
                }
            }
        }
    };
</script>

<style scoped lang="less">
    .top-img {
        height: 150px;
        padding: 0.64rem 0 0 2.48rem;
        background-image: url("../../assets/image/tingdian.png");
        background-size: 100% 100%;
        box-sizing: border-box;
    }

    .content {
        .order {
            border-radius: 10px;
            width: 16.88rem;
            margin: 20px auto 0;
            padding: 40px;
            background-color: #fff;
            font-size: 0.16rem;

            .order-info {
                .top {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;

                    .address-box {
                        margin-bottom: 20px;

                        .address {
                            margin-top: 20px;

                            .address_input {
                                width: 300px;
                            }

                            .address-info {
                                p {
                                    font-size: 0.14rem;
                                    color: #333333;
                                    line-height: 1.2;
                                }
                            }
                        }
                    }
                }
                .top:after {
                    content: "";
                    flex: 0 0 1000px;
                    /* 如何计算233
                          ulist的width是500px，li的width是100px ，根据运行结果，每一行有四个格子，三个间隔，500-100-100-33-33=244，有一点小误差调一调就差不多了
                       */
                }
                .work-cont {
                    width: 30%;
                    /*margin-top: 30px;*/

                    .textarea {
                        height: 100px;
                        background: #f5f5f5;
                        border-radius: 0.06rem;
                        padding: 0.1rem 0.15rem;
                        margin-top: 0.12rem;

                        textarea {
                            width: 100%;
                            height: 100%;
                            font-size: 0.14rem;
                            background: #f5f5f5;
                            outline: none;
                            border: none;
                            resize: none;
                        }

                        textarea::placeholder {
                            color: #bababa;
                        }
                    }
                }
            }

            .bot {
                display: flex;
                justify-content: center;
                /*align-items: flex-end;*/

                .apply {
                    width: 1.38rem;
                    height: 0.4rem;
                    background: #686868;
                    border: 1px solid #686868;
                    border-radius: 0.09rem;
                    font-size: 0.14rem;
                    color: #ffffff;
                    line-height: 0.4rem;
                    text-align: center;
                    margin-left: 0.35rem;
                    cursor: pointer;
                }

                .saveOrder {
                    width: 1.38rem;
                    height: 0.4rem;
                    background: #ffffff;
                    border: 1px solid #686868;
                    border-radius: 0.09rem;
                    font-size: 0.14rem;
                    color: #686868;
                    line-height: 0.4rem;
                    text-align: center;
                    margin-left: 0.32rem;
                    cursor: pointer;
                }
            }
        }
    }
</style>
